import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { FaUserPlus } from "react-icons/fa";
import { MdClose } from "react-icons/md";

export const AdminManageRunrocketTrainingTemplate = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();

  const [templates, setTemplates] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  const [assignModalOpen, setAssignModalOpen] = useState(false);
const [athleteEmail, setAthleteEmail] = useState("");
const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await fetch(
          `${API_URL.MANAGE_RUNROCKET_TRAINING_TEMPLATES}?page=${page}&limit=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          },
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to fetch templates");
        }

        setTemplates(data.data);
        setFilteredTemplates(data.data); // Initialize filteredTemplates with all data
        setTotalPages(data.totalPages);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTemplates();
  }, [page, staff.token]);

  const filterData = (query) => {
    if (query.trim() === "") {
      setFilteredTemplates(templates);
    } else {
      const lowerQuery = query.toLowerCase();
      const filtered = templates.filter(
        (template) =>
          template.title.toLowerCase().includes(lowerQuery) ||
          (template.status &&
            template.status.toLowerCase().includes(lowerQuery)),
      );
      setFilteredTemplates(filtered);
    }
  };

  useEffect(() => {
    filterData(search);
  }, [search, templates]);


  const handleAssignAthlete = async () => {
    try {
      setIsAssigning(true);
  
      if (!athleteEmail) {
        alert("Please enter athlete email");
        return;
      }
  
      const response = await fetch(
        API_URL.ADMIN_ASSIGN_AST_SPEED_TOOL_TO_ATHLETE + athleteEmail,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
        }
      );
  
      const json = await response.json();
  
      if (!response.ok) {
        alert(json.message || json.error || "Failed to assign tool");
        return;
      }
  
      alert(json.message);
  
      setAthleteEmail("");
      setAssignModalOpen(false);
    } catch (err) {
      console.error(err);
      alert("Something went wrong while assigning.");
    } finally {
      setIsAssigning(false);
    }
  };

  return (
    <div className="md:flex md:h-screen">
      <StaffSideMenu />
      <div className="md:flex-1 bg-bgBase md:flex md:h-screen md:flex-col">
        <div className="bg-white px-5 md:px-10 lg:px-16 py-6">
          <h1 className="font-inter font-medium text-dark text-2xl !leading-none mb-6 max-md:pl-12">
            Manage AST Speed Profile Training Templates
          </h1>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <input
              type="text"
              placeholder="Search by title"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="max-md:min-w-56 lg:w-1/4 p-3 border border-black/10 rounded-lg font-inter font-normal text-sm"
            />

            <button
                onClick={() => {
                    setAthleteEmail("");
                    setAssignModalOpen(true);
                }}
                className="flex items-center gap-2 bg-dark text-white px-4 py-3 rounded-lg hover:bg-black transition"
            >
                <FaUserPlus size={16} />
                <span>Grant Tool Access</span>
            </button>
          </div>
        </div>
        <div className="px-5 md:px-10 lg:px-16 py-6">
          {error && (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">
              {error}
            </div>
          )}
          {isLoading ? (
            <div className="bg-white border border-tblBorder rounded-md w-fit mx-auto py-2 px-5">
              <p className="text-dark text-sm font-inter font-normal text-center">
                Loading...
              </p>
            </div>
          ) : (
            <div className="w-full">
              <div className="overflow-auto show-scrollbar max-h-[680px]">
                <div className="rounded-10 border border-tblBorder w-full">
                  <table className="table-auto table-radius w-full min-w-[570px]">
                    <thead className="sticky top-0 bg-tblHead border-b border-tblBorder text-dark font-inter !font-normal text-sm">
                      <tr>
                        <th className="px-6 py-4 text-left">Title</th>
                        <th className="px-6 py-4 text-left">Description</th>
                        <th className="px-6 py-4 text-left">Build Training</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-tblBorder">
                      {filteredTemplates.map((template, index) => (
                        <tr
                          key={template._id}
                          className={` text-dark font-inter font-normal text-sm bg-white ${index % 2 === 0 ? "bg-gray-50" : "bg-gray-100"}`}
                        >
                          <td className="px-6 py-4">{template.title}</td>
                          <td className="px-6 py-4">{template.description}</td>

                          <td className="px-6 py-4">
                            <Link
                              to={`/administrator/runrocket/templates/training/${template._id}`}
                              className="bg-dark hover:bg-black rounded-10 py-2 px-4 text-white text-sm font-inter font-normal"
                            >
                              Build Training
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="bg-white px-5 md:px-10 lg:px-16 py-4 mt-5 md:mt-auto">
          <div className="flex max-sm:flex-col items-center justify-between">
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
              className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm `}
            >
              <MdKeyboardArrowLeft size={20} /> Previous
            </button>
            <span className="text-dark font-inter font-normal text-sm ">
              Page {page} of {totalPages}
            </span>
            <button
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={page === totalPages}
              className="px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm "
            >
              Next <MdKeyboardArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>


        {assignModalOpen && (
          <div className="fixed inset-0 w-full bg-black bg-opacity-60 p-5 overflow-y-auto flex justify-center">
            <div className="w-full max-w-xl">
              <div className="bg-white rounded-lg shadow-lg">

                <div className="relative py-5 px-6">
                <div>
                    <h2 className="text-dark text-xl font-semibold">
                        Grant Tool Access
                    </h2>

                    <p className="mt-2 text-sm text-gray-500">
                        Enter an athlete's email below to give them direct access to the AST Speed Tool.
                    </p>
                </div>

                  <button
                    onClick={() => setAssignModalOpen(false)}
                    className="absolute top-4 right-6 p-2 rounded hover:bg-gray-200"
                  >
                   <MdClose color="#4A5565" size={18} />
                  </button>
                </div>

                <div className="p-6 border-y border-tblBorder">

                  <div className="rounded-lg border border-gray-200 bg-gray-50 p-5">

                      <label className="block text-sm font-medium text-dark mb-2">
                          Athlete Email
                      </label>

                      <input
                          type="email"
                          value={athleteEmail}
                          onChange={(e) => setAthleteEmail(e.target.value)}
                          placeholder="athlete@email.com"
                          className="w-full border border-tblBorder rounded-md px-3 py-2.5 bg-white"
                      />

                      <p className="mt-2 text-xs text-gray-500">
                          Use the email associated with the athlete's account.
                      </p>

                  </div>
                  <div className="mt-4 rounded-lg border border-blue-100 bg-blue-50 p-4">
                      <p className="text-sm text-blue-700">
                          Granting access allows this athlete to immediately use the AST Speed Tool with their existing accoun or by creating a mew account.
                      </p>
                  </div>

                  </div>

                <div className="p-6 flex justify-end gap-3">
                  <button
                    onClick={() => setAssignModalOpen(false)}
                    className="px-5 py-2.5 border border-tblBorder rounded-lg hover:bg-gray-100"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleAssignAthlete}
                    disabled={isAssigning}
                    className={`px-5 py-2.5 rounded-lg ${
                      isAssigning
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-dark text-white hover:bg-black"
                    }`}
                  >
                    {isAssigning ? "Granting Access..." : "Grant Access"}
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}


    </div>

    
  );
  
};
